<!--DURATION-->
<ng-container *ngIf="showDuration && duration">
  <div [ngClass]="iconClass">
    <!--ICON-->
    <ng-container *ngIf="showIcon">
      <i class="icon time margin-right-small" [ngClass]="[iconColor, iconSize]"></i>
    </ng-container>
    <!--END ICON-->
    <!--DURATION-->
    <!--NOTE: Duration can be in minutes or days-->
    <span class="padding-top-x-small bold">{{ duration }}</span>
    <!--DURATION-->
  </div>
</ng-container>
<!--END DURATION-->
